const MultiColumns = ({ data }: any) => {
    const entries = Object.entries(data);
    const sections = entries.map(([key, items]) => ({
        title: key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()),
        items
    }));

    const isOdd = sections.length % 2 !== 0;

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4 justify-items-center">
            {sections.map((sec: any, index: number) => {
                const isLast = index === sections.length - 1;
                const makeCentered = isOdd && isLast;

                return (
                    <div
                        key={sec.title}
                        className={`flex flex-col items-center w-full ${makeCentered ? "md:col-span-2" : ""}`}
                    >
                        <h3 className="text-xl font-bold text-center mb-1">
                            {sec.title}
                        </h3>

                        <div className="flex flex-col gap-2 w-full max-w-2xl border-[#4A731F] border-4 p-2 rounded-lg">
                            {sec.items.map((text: string, i: number) => (
                                <div
                                    key={i}
                                    className="bg-[#B0DB7D] rounded-lg px-2 py-1 text-center font-medium"
                                >
                                    {text}
                                </div>
                            ))}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default MultiColumns;
